import * as _ from 'underscore'

export interface ICSS {
	CellX: string;
	Disabled: string;
	Dynamic: string;
	Error: string;
	Group: string;
	Selected: string;
	WidgetWrapper: string; 
}; 

export var CSS: ICSS = _.extend({}, CSS, {
	CellX: 'mapp-cell-',
	Disabled: 'disabled',
	Dynamic: 'dynamic',
	Error: 'error',
	Group: 'widget-group no-gutter',
	Selected: 'selected',
	WidgetWrapper: 'widget-wrapper' 
});